// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IvySV__layout {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 100vh;
  background: var(--color-paper-2);
  z-index: 1000;
  overflow-y: auto;
  padding-bottom: 6em;
}

.IvySV__layout a {
    color: var(--color-blue-1);
    -webkit-text-decoration: underline;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

.IvySV__layout a:hover {
      opacity: 0.8;
    }

.MThB0__pageHeader {
  display: flex;
  align-items: center;
  gap: 0.8em;
  padding: 1.5em 1.5em 1.5em;
  max-width: 1240px;
  margin: 0 auto;
}

.MThB0__pageHeader a {
    font-size: 1.5em;
    color: var(--color-blue-1);
  }

.MThB0__pageHeader h1 {
    margin: 0;
  }

/* Hero — the night-ops band. This page inquires about the Mission Control
   film, so it borrows the film's dark visual world regardless of the OS
   color scheme; the sections below return to the site's normal paper. */
.iEdR9__hero {
  background:
    radial-gradient(120% 140% at 80% -20%, #0a3552 0%, transparent 55%),
    linear-gradient(165deg, #011a24 0%, #0d0f11 70%);
  color: white;
  border-top: 3px solid var(--color-red-1);
}
.iEdR9__hero a {
    -webkit-text-decoration: none;
    text-decoration: none;
  }

.SnZlm__headerLogo {
  width: 2.4em;
  border-radius: 50%;
}

._VhnH__heroInner {
  display: flex;
  flex-direction: column;
  gap: 2em;
  max-width: 1240px;
  margin: 0 auto;
  padding: 3.5em 1.5em 4.5em;
}

@media screen and (min-width: 1024px) {

._VhnH__heroInner {
    flex-direction: row;
    align-items: center;
    gap: 3em;
}
  }

._WyLe__heroCopy {
  flex: 1;
}

._WyLe__heroCopy h2 {
    font-size: 2.6em;
    line-height: 1.1;
    margin: 0 0 0.4em;
  }

@media screen and (min-width: 1024px) {

._WyLe__heroCopy h2 {
      font-size: 3.2em;
  }
    }

._7TPz__eyebrow {
  color: #48dbfb;
  font-size: 0.85em;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  margin-bottom: 1.2em;
}

.RHOVt__heroSub {
  font-size: 1.15em;
  line-height: 1.55;
  opacity: 0.85;
  max-width: 34em;
}

.s31l6__heroLinks {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8em;
  margin-top: 1.8em;
}

.lhm8t__heroShot {
  flex: 1.1;
  margin: 0;
  min-width: 0;
}

.lhm8t__heroShot img {
    display: block;
    width: 100%;
    border-radius: 8px;
    border: 1px solid rgba(72, 219, 251, 0.25);
    box-shadow:
      0 0 40px rgba(9, 132, 227, 0.25),
      0 24px 48px rgba(0, 0, 0, 0.5);
  }

.lhm8t__heroShot figcaption {
    margin-top: 0.7em;
    font-size: 0.8em;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    opacity: 0.55;
    text-align: right;
  }

/* Inquiry form — pulled up over the hero's lower edge so the page reads as
   one composition instead of band-stacked sections. */
.hwPXA__inquire {
  max-width: 760px;
  margin: -2.5em auto 0;
  padding: 0 1.5em;
  position: relative;
}

.EjZ0j__formCard {
  padding: 2em 1.5em;
}

@media screen and (min-width: 640px) {

.EjZ0j__formCard {
    padding: 2.5em 2.5em;
}
  }

.EjZ0j__formCard h2 {
    margin: 0 0 0.4em;
  }

.l_BDM__formLede {
  opacity: 0.75;
  margin-top: 0;
}

.uvj8H__form {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  margin-top: 1.5em;
}

.Aag5R__formRow {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}

@media screen and (min-width: 640px) {

.Aag5R__formRow {
    flex-direction: row;
    gap: 1em;
}

    .Aag5R__formRow > * {
      flex: 1;
    }
  }

.kjZ9I__fieldset {
  margin: 0.5em 0;
}

.bPafL__chipRow {
  flex-wrap: wrap;
  gap: 0.5em;
  margin-top: 0.5em;
}

.L7Uqv__website {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  -webkit-clip-path: inset(50%);
          clip-path: inset(50%);
  white-space: nowrap;
}

.zEs3V__submit {
  align-self: flex-start;
  font-size: 1.15em;
  margin-top: 1em;
}

.kwo4s__formNote {
  font-size: 0.85em;
  opacity: 0.6;
  margin-bottom: 0;
}

.Rxd4F__sentIcon {
  font-size: 3em;
  color: var(--color-green-1);
  margin-bottom: 0.2em;
}

/* Content sections */
.DIPik__section {
  max-width: 760px;
  margin: 0 auto;
  padding: 2.5em 1.5em 0;
}
.DIPik__section h2 {
    margin: 0 0 0.8em;
  }

.ZbImf__featureList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.8em;
}

.ZbImf__featureList li {
    display: flex;
    gap: 0.8em;
    align-items: baseline;
    line-height: 1.5;
  }

.d0ymw__checkIcon {
  color: var(--color-green-1);
  flex-shrink: 0;
}

.FZpVP__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6em;
  margin: 1em 0;
}

.it14M__chip {
  border: 1px dashed var(--color-blue-1);
  color: var(--color-blue-1);
  border-radius: 999px;
  padding: 0.35em 1em;
  font-size: 0.9em;
  font-weight: bold;
}

.Us0Fx__sectionNote {
  opacity: 0.75;
}

.slTUx__steps {
  margin: 0;
  padding-left: 1.3em;
  display: flex;
  flex-direction: column;
  gap: 0.8em;
}

.slTUx__steps li {
    line-height: 1.5;
    padding-left: 0.3em;
  }

.aV7cV__footer {
  max-width: 760px;
  margin: 0 auto;
  padding: 3em 1.5em 0;
  font-size: 0.9em;
  opacity: 0.75;
}
`, "",{"version":3,"sources":["webpack://./src/app/routes/teams/TeamsRoute.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AAWrB;;AATE;IACE,0BAA0B;IAC1B,kCAA0B;IAA1B,0BAA0B;IAC1B,0BAA0B;EAK5B;;AAHE;MACE,YAAY;IACd;;AAIJ;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;AAUhB;;AARE;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;AAEA;IACE,SAAS;EACX;;AAGF;;wEAEwE;AACxE;EACE;;oDAEkD;EAClD,YAAY;EACZ,wCAAwC;AAK1C;AAHE;IACE,6BAAqB;IAArB,qBAAqB;EACvB;;AAGF;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,0BAA0B;AAO5B;;AALE;;AARF;IASI,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AAEZ;EADE;;AAGF;EACE,OAAO;AAWT;;AATE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EAKnB;;AAHE;;AALF;MAMI,gBAAgB;EAEpB;IADE;;AAIJ;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,YAAY;AAoBd;;AAlBE;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,0CAA0C;IAC1C;;oCAEgC;EAClC;;AAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,iBAAiB;EACnB;;AAGF;sDACsD;AACtD;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AASpB;;AAPE;;AAHF;IAII,oBAAoB;AAMxB;EALE;;AAEA;IACE,iBAAiB;EACnB;;AAGF;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AAUZ;;AARE;;AALF;IAMI,mBAAmB;IACnB,QAAQ;AAMZ;;IAJI;MACE,OAAO;IACT;EACF;;AAGF;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,6BAAqB;UAArB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AAKxB;AAHE;IACE,iBAAiB;EACnB;;AAGF;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,UAAU;AAQZ;;AANE;IACE,aAAa;IACb,UAAU;IACV,qBAAqB;IACrB,gBAAgB;EAClB;;AAGF;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,UAAU;AAMZ;;AAJE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;AAGF;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf","sourcesContent":[".layout {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 100vh;\n  background: var(--color-paper-2);\n  z-index: 1000;\n  overflow-y: auto;\n  padding-bottom: 6em;\n\n  & a {\n    color: var(--color-blue-1);\n    text-decoration: underline;\n    text-underline-offset: 2px;\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n}\n\n.pageHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.8em;\n  padding: 1.5em 1.5em 1.5em;\n  max-width: 1240px;\n  margin: 0 auto;\n\n  & a {\n    font-size: 1.5em;\n    color: var(--color-blue-1);\n  }\n\n  & h1 {\n    margin: 0;\n  }\n}\n\n/* Hero — the night-ops band. This page inquires about the Mission Control\n   film, so it borrows the film's dark visual world regardless of the OS\n   color scheme; the sections below return to the site's normal paper. */\n.hero {\n  background:\n    radial-gradient(120% 140% at 80% -20%, #0a3552 0%, transparent 55%),\n    linear-gradient(165deg, #011a24 0%, #0d0f11 70%);\n  color: white;\n  border-top: 3px solid var(--color-red-1);\n\n  & a {\n    text-decoration: none;\n  }\n}\n\n.headerLogo {\n  width: 2.4em;\n  border-radius: 50%;\n}\n\n.heroInner {\n  display: flex;\n  flex-direction: column;\n  gap: 2em;\n  max-width: 1240px;\n  margin: 0 auto;\n  padding: 3.5em 1.5em 4.5em;\n\n  @media (--screen-lg) {\n    flex-direction: row;\n    align-items: center;\n    gap: 3em;\n  }\n}\n\n.heroCopy {\n  flex: 1;\n\n  & h2 {\n    font-size: 2.6em;\n    line-height: 1.1;\n    margin: 0 0 0.4em;\n\n    @media (--screen-lg) {\n      font-size: 3.2em;\n    }\n  }\n}\n\n.eyebrow {\n  color: #48dbfb;\n  font-size: 0.85em;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  margin-bottom: 1.2em;\n}\n\n.heroSub {\n  font-size: 1.15em;\n  line-height: 1.55;\n  opacity: 0.85;\n  max-width: 34em;\n}\n\n.heroLinks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.8em;\n  margin-top: 1.8em;\n}\n\n.heroShot {\n  flex: 1.1;\n  margin: 0;\n  min-width: 0;\n\n  & img {\n    display: block;\n    width: 100%;\n    border-radius: 8px;\n    border: 1px solid rgba(72, 219, 251, 0.25);\n    box-shadow:\n      0 0 40px rgba(9, 132, 227, 0.25),\n      0 24px 48px rgba(0, 0, 0, 0.5);\n  }\n\n  & figcaption {\n    margin-top: 0.7em;\n    font-size: 0.8em;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    opacity: 0.55;\n    text-align: right;\n  }\n}\n\n/* Inquiry form — pulled up over the hero's lower edge so the page reads as\n   one composition instead of band-stacked sections. */\n.inquire {\n  max-width: 760px;\n  margin: -2.5em auto 0;\n  padding: 0 1.5em;\n  position: relative;\n}\n\n.formCard {\n  padding: 2em 1.5em;\n\n  @media (--screen-md) {\n    padding: 2.5em 2.5em;\n  }\n\n  & h2 {\n    margin: 0 0 0.4em;\n  }\n}\n\n.formLede {\n  opacity: 0.75;\n  margin-top: 0;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5em;\n  margin-top: 1.5em;\n}\n\n.formRow {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5em;\n\n  @media (--screen-md) {\n    flex-direction: row;\n    gap: 1em;\n\n    & > * {\n      flex: 1;\n    }\n  }\n}\n\n.fieldset {\n  margin: 0.5em 0;\n}\n\n.chipRow {\n  flex-wrap: wrap;\n  gap: 0.5em;\n  margin-top: 0.5em;\n}\n\n.website {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip-path: inset(50%);\n  white-space: nowrap;\n}\n\n.submit {\n  align-self: flex-start;\n  font-size: 1.15em;\n  margin-top: 1em;\n}\n\n.formNote {\n  font-size: 0.85em;\n  opacity: 0.6;\n  margin-bottom: 0;\n}\n\n.sentIcon {\n  font-size: 3em;\n  color: var(--color-green-1);\n  margin-bottom: 0.2em;\n}\n\n/* Content sections */\n.section {\n  max-width: 760px;\n  margin: 0 auto;\n  padding: 2.5em 1.5em 0;\n\n  & h2 {\n    margin: 0 0 0.8em;\n  }\n}\n\n.featureList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.8em;\n\n  & li {\n    display: flex;\n    gap: 0.8em;\n    align-items: baseline;\n    line-height: 1.5;\n  }\n}\n\n.checkIcon {\n  color: var(--color-green-1);\n  flex-shrink: 0;\n}\n\n.chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6em;\n  margin: 1em 0;\n}\n\n.chip {\n  border: 1px dashed var(--color-blue-1);\n  color: var(--color-blue-1);\n  border-radius: 999px;\n  padding: 0.35em 1em;\n  font-size: 0.9em;\n  font-weight: bold;\n}\n\n.sectionNote {\n  opacity: 0.75;\n}\n\n.steps {\n  margin: 0;\n  padding-left: 1.3em;\n  display: flex;\n  flex-direction: column;\n  gap: 0.8em;\n\n  & li {\n    line-height: 1.5;\n    padding-left: 0.3em;\n  }\n}\n\n.footer {\n  max-width: 760px;\n  margin: 0 auto;\n  padding: 3em 1.5em 0;\n  font-size: 0.9em;\n  opacity: 0.75;\n}\n"],"sourceRoot":""}]);
// Exports
export var layout = `IvySV__layout`;
export var pageHeader = `MThB0__pageHeader`;
export var hero = `iEdR9__hero`;
export var headerLogo = `SnZlm__headerLogo`;
export var heroInner = `_VhnH__heroInner`;
export var heroCopy = `_WyLe__heroCopy`;
export var eyebrow = `_7TPz__eyebrow`;
export var heroSub = `RHOVt__heroSub`;
export var heroLinks = `s31l6__heroLinks`;
export var heroShot = `lhm8t__heroShot`;
export var inquire = `hwPXA__inquire`;
export var formCard = `EjZ0j__formCard`;
export var formLede = `l_BDM__formLede`;
export var form = `uvj8H__form`;
export var formRow = `Aag5R__formRow`;
export var fieldset = `kjZ9I__fieldset`;
export var chipRow = `bPafL__chipRow`;
export var website = `L7Uqv__website`;
export var submit = `zEs3V__submit`;
export var formNote = `kwo4s__formNote`;
export var sentIcon = `Rxd4F__sentIcon`;
export var section = `DIPik__section`;
export var featureList = `ZbImf__featureList`;
export var checkIcon = `d0ymw__checkIcon`;
export var chips = `FZpVP__chips`;
export var chip = `it14M__chip`;
export var sectionNote = `Us0Fx__sectionNote`;
export var steps = `slTUx__steps`;
export var footer = `aV7cV__footer`;
export default ___CSS_LOADER_EXPORT___;
